import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useLang } from '../contexts/LanguageContext';

const gold = '#C8A96E';

export default function Login() {
  const { login } = useAuth();
  const { t } = useLang();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setTimeout(() => setMounted(true), 100);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center relative overflow-hidden">

      {/* Background subtle */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 rounded-full blur-3xl" style={{ background: gold }} />
        <div className="absolute bottom-1/4 right-1/4 w-64 h-64 rounded-full blur-3xl" style={{ background: gold }} />
      </div>

      {/* Login card */}
      <div className="relative z-10 w-full max-w-md px-6"
        style={{
          opacity: mounted ? 1 : 0,
          transform: mounted ? 'translateY(0)' : 'translateY(20px)',
          transition: 'all 1s cubic-bezier(0.22, 1, 0.36, 1)',
        }}>

        {/* Logo / Marque */}
        <div className="text-center mb-12">
          <img src="/photos/Logo_fd_transparent.png" alt="Pernety" className="h-16 mx-auto mb-6 invert opacity-80" />
          <h1 className="font-serif text-3xl text-white tracking-wide">Pernety</h1>
          <div className="flex items-center justify-center gap-3 mt-3">
            <div className="w-8 h-px" style={{ background: `linear-gradient(90deg, transparent, ${gold})` }} />
            <p className="text-xs tracking-[0.25em] uppercase" style={{ color: `${gold}99` }}>{t('login.privateArea')}</p>
            <div className="w-8 h-px" style={{ background: `linear-gradient(90deg, ${gold}, transparent)` }} />
          </div>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-6">

          {error && (
            <div className="text-center py-3 text-sm text-red-400/80 border border-red-400/20 rounded-sm bg-red-400/5">
              {error}
            </div>
          )}

          <div>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={t('login.emailPlaceholder')}
              required
              className="w-full bg-transparent border-b border-white/10 focus:border-white/30 outline-none py-3 text-white text-sm tracking-wide placeholder-white/20 transition-colors duration-500"
              style={{ caretColor: gold }}
            />
          </div>

          <div>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder={t('login.passwordPlaceholder')}
              required
              className="w-full bg-transparent border-b border-white/10 focus:border-white/30 outline-none py-3 text-white text-sm tracking-wide placeholder-white/20 transition-colors duration-500"
              style={{ caretColor: gold }}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 mt-4 text-xs tracking-[0.2em] uppercase transition-all duration-500 border"
            style={{
              color: loading ? '#666' : gold,
              borderColor: loading ? '#333' : `${gold}40`,
              background: loading ? 'transparent' : `${gold}08`,
            }}
            onMouseEnter={(e) => { if (!loading) { e.target.style.background = `${gold}15`; e.target.style.borderColor = `${gold}80`; } }}
            onMouseLeave={(e) => { if (!loading) { e.target.style.background = `${gold}08`; e.target.style.borderColor = `${gold}40`; } }}
          >
            {loading ? t('login.submitting') : t('login.submit')}
          </button>
        </form>

        {/* Footer */}
        <p className="text-center mt-12 text-[10px] tracking-[0.15em] uppercase text-white/15">
          {t('login.footer')}
        </p>
      </div>
    </div>
  );
}
